import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const headList: any[] = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "共済契約者氏名",
    keyword: "corpName",
    type: "label",
    disabled: true,
  },
  {
    title: "施設名",
    keyword: "facilityName",
    type: "label",
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "label",
    disabled: true,
  },
  {
    title: "職員生年月日",
    keyword: "staffBirthday",
    type: "date",
    disabled: true,
  },
  {
    title: "確認する書類の選択",
    keyword: "identificationDocsKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList({
      "個人番号カード（１２桁の番号のある面）": "1",
      "個人番号が記載された住民票＋写真付き身分証明１点": "2",
      "個人番号が記載された住民票＋写真無し身分証明２点": "3",
      "通知カード＋写真付き身分証明１点": "4",
      "通知カード＋写真無し身分証明２点": "5",
    }),
    disabled: true,
  },
  {
    title: "個人番号を確認する書類",
    keyword: "myNumberDoc",
    type: "downloadLink",
    id: "1",
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDoc",
    type: "downloadLink",
    id: "2",
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "identityDocHead",
    type: "downloadLink",
    id: "3",
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "identityDocTail",
    type: "downloadLink",
    id: "4",
    downloadBase64: true,
  },
  {
    title: "契約者名",
    keyword: "corpName2",
    type: "text",
  },
  {
    title: "契約者住所",
    keyword: "location",
    type: "text",
  },
  {
    title: "施設名",
    keyword: "facilityName2",
    type: "text",
  },
  {
    title: "職員名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "premiumEnroll",
    type: "text",
  },
];

const schema: any = {
  memo: {
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
};

export { fakeTableList, schema, headList };
